import * as React from "react";

const ButtonV2 = React.forwardRef(({ className = "", children, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={`flex flex-row items-center justify-center text-center
          px-5 py-2.5
          bg-primary text-primary-foreground
          font-bold text-xs
          cursor-pointer border-none
          focus:outline-none
          hover:bg-primary/80 active:bg-primary/90
          disabled:opacity-50 disabled:cursor-not-allowed
          ${className}`}
      {...props}
    >
      {children}
    </button>
  );
});

ButtonV2.displayName = "ButtonV2";

export default ButtonV2;
